import { render, staticRenderFns } from "./UpdateNewsExtra.vue?vue&type=template&id=82b02f1e&scoped=true"
import script from "./UpdateNewsExtra.vue?vue&type=script&lang=js"
export * from "./UpdateNewsExtra.vue?vue&type=script&lang=js"
import style0 from "./UpdateNewsExtra.vue?vue&type=style&index=0&id=82b02f1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b02f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82b02f1e')) {
      api.createRecord('82b02f1e', component.options)
    } else {
      api.reload('82b02f1e', component.options)
    }
    module.hot.accept("./UpdateNewsExtra.vue?vue&type=template&id=82b02f1e&scoped=true", function () {
      api.rerender('82b02f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/UpdateNewsExtra.vue"
export default component.exports